import type { ThemeMode } from '@/hooks/useLightMode'
import { HiOutlineHome } from 'react-icons/hi2'

import { Flex, Stack, Text } from '@hivewatch/dark'

import {
  settingsColorToken,
  settingsStateBodyTextColorToken,
} from '../utils/settingsColorToken'

interface SettingsPolicyNoteIProps {
  colorScheme: ThemeMode
  title: string
  description: string
}

/**
 * A note telling the user which way an organization-wide policy is set, for
 * example "You control Critical incident sounds" under the personal Audio
 * controls (ENG-35923). Visually tied to the organization policy card: the same
 * success-tinted surface and house glyph, with a leading accent bar.
 */
export const SettingsPolicyNote = ({
  colorScheme,
  title,
  description,
}: SettingsPolicyNoteIProps) => {
  const successColor = settingsColorToken(colorScheme, 'status.success')

  return (
    <Flex
      alignItems='flex-start'
      bg={settingsColorToken(colorScheme, 'bg.org-policy')}
      borderLeftColor={settingsColorToken(colorScheme, 'border.org-policy')}
      borderLeftWidth='3px'
      data-testid='settings-policy-note'
      gap='11px'
      px='13px'
      py='11px'
      w='full'
    >
      <Flex color={successColor} flexShrink={0} pt='2px'>
        <HiOutlineHome size={18} />
      </Flex>
      <Stack gap='2px'>
        <Text
          color={settingsColorToken(colorScheme, 'text.primary')}
          textStyle='label'
        >
          {title}
        </Text>
        {/* text.secondary reads dim on the success-tinted surface in dark. */}
        <Text
          color={settingsStateBodyTextColorToken(colorScheme)}
          textStyle='caption'
        >
          {description}
        </Text>
      </Stack>
    </Flex>
  )
}
